export default {
  namespaced: true,
  state: {
    showTagsview: true,
  },
};
